const ENDPOINT = "https://ws.geonorge.no/hoydedata/v1/punkt";
const BATCH_SIZE = 50;
const TIMEOUT_MS = 30000;

export async function fetchAltitudes(coordinates) {
  const altitudes = [];

  // Keep requests sequential to avoid flooding the service for long routes.
  for (let offset = 0; offset < coordinates.length; offset += BATCH_SIZE) {
    const points = coordinates
      .slice(offset, offset + BATCH_SIZE)
      .map(([longitude, latitude]) => [longitude, latitude]);
    const params = new URLSearchParams({
      koordsys: "4326",
      punkter: JSON.stringify(points),
    });
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS);

    try {
      const response = await fetch(`${ENDPOINT}?${params}`, {
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(`Høydetjenesten svarte med HTTP ${response.status}.`);
      }

      const data = await response.json();
      if (!Array.isArray(data.punkter) || data.punkter.length !== points.length) {
        throw new Error("Høydetjenesten returnerte et ufullstendig svar.");
      }

      data.punkter.forEach((point, index) => {
        if (
          !Number.isFinite(point?.z) ||
          point.x !== points[index][0] ||
          point.y !== points[index][1]
        ) {
          throw new Error("Høydedata mangler eller er ugyldige for deler av ruten.");
        }
        altitudes.push(point.z);
      });
    } finally {
      clearTimeout(timeout);
    }
  }

  return altitudes;
}
